var SpriteSymbol = require("../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/.pnpm/rspack-svg-sprite-loader@6.0.12/node_modules/rspack-svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "icon-sprite-icon_arrow",
  "use": "icon-sprite-icon_arrow-usage",
  "viewBox": "0 0 15 26",
  "content": "<symbol viewBox=\"0 0 15 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sprite-icon_arrow\"><path stroke=\"var(--arrow-color,#D6D6D6)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 2l11.524 10.908L2.09 24\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol